import { api } from './client';
import type { PaginatedResponse } from './types';

// ---------------------------------------------------------------------------
// Landing "book a demo" requests — public submit + platform console
// ---------------------------------------------------------------------------

export type DemoRequestStatus = 'new' | 'contacted' | 'closed';

export interface DemoRequest {
  id: number;
  name: string;
  phone: string;
  email: string | null;
  company_name: string | null;
  message: string | null;
  status: DemoRequestStatus;
  created_at: string | null;
  updated_at: string | null;
}

export interface DemoRequestPayload {
  name: string;
  phone: string;
  email?: string;
  company_name?: string;
  message?: string;
  /** Honeypot — must stay empty; bots that fill it are silently dropped. */
  website?: string;
}

export async function submitDemoRequest(payload: DemoRequestPayload): Promise<void> {
  await api.post('/public/demo-requests', payload);
}

export async function listDemoRequests(params: {
  page?: number;
  per_page?: number;
  status?: DemoRequestStatus;
}): Promise<PaginatedResponse<DemoRequest>> {
  const { data } = await api.get<PaginatedResponse<DemoRequest>>('/platform/demo-requests', {
    params,
  });
  return data;
}

export async function updateDemoRequestStatus(
  id: number,
  status: DemoRequestStatus,
): Promise<DemoRequest> {
  const { data } = await api.patch<{ data: DemoRequest }>(`/platform/demo-requests/${id}`, {
    status,
  });
  return data.data;
}
